import { render, staticRenderFns } from "./StockActionItemsPreviewTable.vue?vue&type=template&id=a58cc3d4&scoped=true&"
import script from "./StockActionItemsPreviewTable.vue?vue&type=script&lang=js&"
export * from "./StockActionItemsPreviewTable.vue?vue&type=script&lang=js&"
import style0 from "./StockActionItemsPreviewTable.vue?vue&type=style&index=0&id=a58cc3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58cc3d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VDataTable,VIcon,VTextField})
